module.exports = __webpack_public_path__ + "static/media/echeq__emit-icon.92fe9a7e.svg";